module.exports = __webpack_public_path__ + "static/media/icon-benefit-checkmark.1516c5ce.svg";